import _ from 'lodash';

const mapUtils = {

  mapPointToArray(point) {
    // take raw google maps center object and return [long, lat]
    return [point.lng(), point.lat()]; // https://developers.google.com/maps/documentation/javascript/reference#LatLng
  }

  , mapPointToString(point) {
    return this.mapPointToArray(point).join(",");
  }

  , mapBoundsToArray(bounds) {
    // take raw google maps bounds object and return [long,lat,long,lat,...]
    // https://developers.google.com/maps/documentation/javascript/reference#LatLngBounds
    // we want: [west,south,west,north,east,north,east,south]
    const b = bounds.toJSON();
    return [b.west, b.south, b.west, b.north, b.east, b.north, b.east, b.south];
  }

  , mapViewportToBoundsString(bounds) {
    return this.mapBoundsToArray(bounds).join(",")
  }

  , geoPointDisplayToDB(coordinates) {
    // console.log("google coordinates")
    // console.log(coordinates);
    // let newCoordinates = coordinates.map(())
  }

  , geoPointDbToDisplay(coordinates) {
    // console.log("database coordinates")
    // console.log(coordinates);
    // let newCoordinates;
  }

  , polygonDisplayToDb(coordinates) {
    return coordinates.map((o)=> [o.lng(), o.lat()] )
  }

  , polygonDbToDisplay(coordinates) {
    return coordinates.map((a) => ({ lat: a[1], lng: a[0]}))
  }

  , extractAddress(components) {
    let a = {
      city: ""
      , country: ""
      , postal: ""
      , state: ""
      , street1: ""
      , street2: ""
    }
    _.each(components, (c) => {
      if(c.types[0] === "street_number") {
        a.street1 = c.long_name + a.street1;
      } else if(c.types[0] === "route") {
        a.street1 += " " + c.long_name;
      } else if(c.types[0] === "locality") {
        a.city = c.long_name;
      } else if(c.types[0] === "administrative_area_level_1") {
        a.state = c.short_name;
      } else if(c.types[0] === "country") {
        a.country = c.short_name;
      } else if(c.types[0] === "postal_code") {
        a.postal = c.long_name;
      }
    })
    return a;
  }

  , returnMapsKey() {
    return 'AIzaSyDwaEV_97GKqXGA55ky22DrsSaZQzj9uuA';
  }

}

export default mapUtils;



// WEBPACK FOOTER //
// global/utils/mapUtils.js